'use strict';

angular.module('msOnboarding').directive('msOnboardingHeader', [function () {
  return {
    templateUrl: 'onboarding/templates/onboardingHeader.html',
    restrict: 'E',
    controller: 'OnboardingHeaderCtrl',
    controllerAs: 'vm',
    bindToController: true
  };
}]).controller('OnboardingHeaderCtrl', ['$log', 'onboardingRouter', 'authenticationRouter', 'NotifyingSvc', '$rootScope', '$scope', '$timeout', function ($log, onboardingRouter, authenticationRouter, NotifyingSvc, $rootScope, $scope, $timeout) {
  var vm = this;

  vm.$onInit = _activate;
  var cleanUpEventWatcher = void 0;

  function _activate() {
    // Initialize
    _setFeatureVisibility();
    _setStepForView();

    // Register Event Listeners
    cleanUpEventWatcher = $rootScope.$on('$stateChangeSuccess', _setStepForView);
    $scope.$on('$destroy', function () {
      cleanUpEventWatcher();
    });

    [NotifyingSvc.EVENTS.USER_SIGNUP_COMPLETE, NotifyingSvc.EVENTS.USER_LOGIN_COMPLETE, NotifyingSvc.USER_OAUTH_LOGIN].forEach(function (evt) {
      return NotifyingSvc.subscribe(evt, function (event, data) {
        if (data) {
          //on auth load
          _setFeatureVisibility();
        }
      });
    });
  }

  // When setting which step to display, there are two states to account for:
  // 1. Initial state where no step is set and only the logo is displayed
  // 2. The "on a step" state where the steps are displayed 
  // The user might enter at either of those states (by refreshing the page),
  // so we need to consider the variables between those states.
  function _setStepForView() {
    // Occurs on page reload, when vm.step has not been set.
    // If this case, display everythign right away. No animation.
    if (_.isUndefined(vm.step)) {
      vm.step = authenticationRouter.getCurrentOnboardingStep();
      vm.disableSave = vm.step === null ? true : false;
      vm.showSteps = true;
    }
    // Occurs when entering step 1 from the welcome page.
    if (vm.step === null) {
      vm.showSteps = false;
      vm.step = authenticationRouter.getCurrentOnboardingStep();
      vm.disableSave = vm.step === null ? true : false;
      $timeout(function () {
        vm.showSteps = true;
      }, 1000);
    } else if (vm.step > authenticationRouter.getCurrentOnboardingStep()) {
      // Occurs when navigating back in the browser's histroy.
      vm.step = authenticationRouter.getCurrentOnboardingStep();
      vm.disableSave = vm.step === null ? true : false;
      vm.showSteps = true;
    }
    // Occurs after completing the previous step.
    // This has an extra delay to account for the overlay 
    else {
        $timeout(function () {
          vm.step = authenticationRouter.getCurrentOnboardingStep();
          vm.disableSave = vm.step === null ? true : false;
        }, 2500);
        $timeout(function () {
          vm.showSteps = true;
        }, 1000);
      }
  }

  function _setFeatureVisibility() {

    vm.onboardingStepFeatureVisible = onboardingRouter.getFeatureVisibility();
    vm.steps = [{
      displayName: 'account',
      displayIcon: 'userprofile',
      visibility: vm.onboardingStepFeatureVisible[0]
    }, {
      displayName: 'mood',
      displayIcon: 'activity',
      visibility: vm.onboardingStepFeatureVisible[1]
    }, {
      displayName: 'assessment',
      displayIcon: 'clipboard',
      visibility: vm.onboardingStepFeatureVisible[2]
    }, {
      displayName: 'customization',
      displayIcon: 'user',
      visibility: vm.onboardingStepFeatureVisible[3]
    }];
  }
}]);